import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {BehaviorSubject, Observable} from "rxjs";
import {map, shareReplay} from "rxjs/operators";
import {Poses, Pos, LatLng} from "../model/PosModel";

const CACHE_SIZE = 1;

@Injectable({
  providedIn: 'root'
})
export class GMapService {

  private posesURL = environment.links.poses.response;
  private cache$: Observable<Pos[]>;

  private citySource = new BehaviorSubject<string>('');
  private  geoSource = new BehaviorSubject<boolean>(false);
  private  geoLatlongSource = new BehaviorSubject<null|LatLng>(null);
  currentCity = this.citySource.asObservable();
  geoRunner = this.geoSource.asObservable();
  currentLocation = this.geoLatlongSource.asObservable();

  constructor(private http: HttpClient) {

  }

  private requestPoses() {
    return this.http.get<Poses>(this.posesURL).pipe(
      map(response => response.poses)
    );
  }

  get poses() {
    if(!this.cache$) {
      this.cache$ = this.requestPoses().pipe(
        shareReplay(CACHE_SIZE)
      );
    }

    return this.cache$;
  }

  getData() {
    return this.http.get(this.posesURL);
  }

  changeCity(_city) {
    this.citySource.next(_city);
  }

  runGeo(_geo) {
    this.geoSource.next(_geo);
  }

  setCurrentLatlong(_lat, _lng) {
    this.geoLatlongSource.next({lat: _lat, lng: _lng});
  }

}
